// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"4aec9a1f","196":"1ace17a4","453":"db6ccebd","857":"208601a8"}[chunkId] + ".chunk.js";
};